module.exports = __webpack_public_path__ + "img/36.1b467e48.jpg";